import { useEffect } from 'react';
import { failUfoExperience } from '../index';
export var useColumnPickerRenderedFailedUfoExperience = function useColumnPickerRenderedFailedUfoExperience(status, experienceId) {
  useEffect(function () {
    if (status === 'rejected' && experienceId) {
      failUfoExperience({
        name: 'column-picker-rendered'
      }, experienceId);
    }
  }, [experienceId, status]);
};